import menu from './menu.js'
import rights from './rights.js'
import table from './table.js'

export default {
    name: 'Name',
    nameDescription: 'Der Name sollte nicht dem Sinn nach verändert werden.',
    priority: 'Priorität',
    priorityDescription: 'Eine Erhebung mit einer höheren Priorität kann eine Erhebung mit einer niedrigeren Priorität überschreiben, sofern die Statistikformulare den gleichen Typ haben.',
    color: 'Farbe',
    colorDescription: 'Die Farbe wird um ein Feld, das zu dieser Erhebung gehört angezeigt.',
    logo: 'Logo',

    saveSuccess: 'Die Erhebung wurde erfolgreich gespeichert.',

    deleteStatisticSurvey: 'Erhebung löschen',
    deleteStatisticSurveyText: 'Möchtest du diese Erhebung wirklich löschen?',
    deleteStatisticSurveySuccess: 'Erhebung wurde erfolgreich gelöscht.',
    deleteStatisticSurveyError: 'Die Erhebung konnte nicht gelöscht werden.',

    colors: {
        gray: 'Grau',
        red: 'Rot',
        yellow: 'Gelb',
        green: 'Grün',
        blue: 'Blau',
        purple: 'Lila',
    },

    menu,
    rights,
    table
}